import { createContext, useContext } from "react";

export const ActionContext = createContext({
  setActions: () => {},
});

export const useAction = () => useContext(ActionContext);
